export const FEATURE_GATES = [
  'bts-ui.enable-savings-plans',
  'bts-ui.enable-crypto-transfers',
  'bts-ui.frontend.enable-tax-details-on-offer-accept',
  'bts-ui.enable-staking',
  'bts-ui.enable-fiat-transfers',
  'bts-ui.enable-auto-staking',
  'bts-ui.disable-self-hosted-wallet',
  'bts-ui.enable-swaps',
  'bts-ui.frontend.enable-swaps-new-label',
  'bts-ui.enable-orders',
  'bts-ui.frontend.enable-payment-method-visible-on-accept',
  'bts-ui.frontend.enable-small-discover-header-with-search',
  'bts-ui.frontend.enable-small-discover-header-without-search',
  'bts-ui.frontend.enable-asset-classification-field',
  'bts-ui.frontend.enable-tax-withheld-field',
  'bts-ui.frontend.enable-asset-details-related-transactions',
  'bts-ui.frontend.enable-multiple-currency-asset-price',
  'bts-ui.frontend.enable-two-factor-authentication',
  'bts-ui.enable-segment-limits',
  'bts-ui.frontend.enable-account-level',
  'bts-ui.enable-uk',
  'bts-ui.frontend.enable-islamic-banking',
  'bts-ui.frontend.enable-asset-tag-filtering',
  'bts-ui.frontend.enable-asset-details-market-closed-banner',
] as const;

export type FeatureGateName = (typeof FEATURE_GATES)[number];

export const STATSIG_GATE_MAP = {
  feature_hasSavingsPlansEnabled: 'bts-ui.enable-savings-plans',
  feature_hasCryptoTransfersEnabled: 'bts-ui.enable-crypto-transfers',
  feature_areTaxDetailsShownOnOfferAccept:
    'bts-ui.frontend.enable-tax-details-on-offer-accept',
  feature_hasStakingEnabled: 'bts-ui.enable-staking',
  feature_hasAutoStakingEnabled: 'bts-ui.enable-auto-staking',
  feature_disableSelfHostedWallet: 'bts-ui.disable-self-hosted-wallet',
  feature_hasSwapTradeEnabled: 'bts-ui.enable-swaps',
  feature_showSwapTradeNewLabel: 'bts-ui.frontend.enable-swaps-new-label',
  feature_hasOrdersEnabled: 'bts-ui.enable-orders',
  feature_isPaymentMethodVisibleOnAccept:
    'bts-ui.frontend.enable-payment-method-visible-on-accept',
  feature_usesSmallDiscoverHeaderWithSearch:
    'bts-ui.frontend.enable-small-discover-header-with-search',
  feature_usesSmallDiscoverHeaderWithoutSearch:
    'bts-ui.frontend.enable-small-discover-header-without-search',
  feature_showAssetClassification:
    'bts-ui.frontend.enable-asset-classification-field',
  feature_showTaxWitheldForCryptoTransactions:
    'bts-ui.frontend.enable-tax-withheld-field',
  feature_enableFiatTransfers: 'bts-ui.enable-fiat-transfers',
  feature_showAssetDetailsRelatedTransactions:
    'bts-ui.frontend.enable-asset-details-related-transactions',
  feature_showMultipleCurrencyAssetPrice:
    'bts-ui.frontend.enable-multiple-currency-asset-price',
  feature_twoFactorAuthentication:
    'bts-ui.frontend.enable-two-factor-authentication',
  feature_showSegmentLimitsError: 'bts-ui.enable-segment-limits',
  feature_accountLevel: 'bts-ui.frontend.enable-account-level',
  feature_isUkLicensed: 'bts-ui.enable-uk',
  feature_islamicBanking: 'bts-ui.frontend.enable-islamic-banking',
  feature_assetTagFiltering: 'bts-ui.frontend.enable-asset-tag-filtering',
  feature_assetDetailsMarketClosedBanner:
    'bts-ui.frontend.enable-asset-details-market-closed-banner',
} as const satisfies Record<string, FeatureGateName>;

export type FeatureFlagName = keyof typeof STATSIG_GATE_MAP;

const FF_COOKIE_PREFIX = 'ff_';

const ENV_OVERRIDE_PREFIX = 'STATSIG_OVERRIDE_';

export function gateIdToEnvKey(gateId: string): string {
  return ENV_OVERRIDE_PREFIX + gateId.replace(/[.-]/g, '_');
}

export function gateIdToCookieKey(gateId: string): string {
  return FF_COOKIE_PREFIX + gateId;
}

export { FF_COOKIE_PREFIX };
